import { render, staticRenderFns } from "./index.vue?vue&type=template&id=181463d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=181463d1&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=181463d1&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181463d1",
  null
  
)

export default component.exports